'use client'

// next/dynamic's `ssr: false` is only allowed inside a Client Component.
// This module is the client boundary for the root layout's client-only widgets.
import nextDynamic from 'next/dynamic'

export const CookiesPopup = nextDynamic(() => import('@components/popup/cookies-popup'), { ssr: false })
export const LoadingPage = nextDynamic(() => import('@components/loading-page'), { ssr: false })
export const NavigationEvents = nextDynamic(() => import('@components/navigation-events'), { ssr: false })
export const UpdateHistory = nextDynamic(() => import('@modules/_app/update-history'), { ssr: false })
